export default __webpack_public_path__ + "static/media/header-5.9a9ff418.jpg";